import { CloseOutlineIcon, SearchOutlineIcon } from '@carboncopyco/icons';
import { ColorHex } from '../../../constants';
import { InputText } from '../InputText';

export interface InputSearchProps {
  value: string;
  onChange: (value: string | null) => void;
  onSearch?: (value: string) => void;
  placeholder?: string;
  label?: string;
}

export const InputSearch = ({
  onChange,
  onSearch,
  value,
  placeholder,
}: InputSearchProps) => {
  return (
    <div
      className="flex items-center border rounded-lg border-ds-natural-100 bg-white"
      onBlur={() => value && onSearch?.(value)}
    >
      <div className="text-ds-natural-600 ml-2">
        <SearchOutlineIcon
          color={ColorHex.natural200}
          size={20}
        />
      </div>
      <InputText
        state="invisible"
        onKeyDown={(event) =>
          event.code === 'Enter' && value && onSearch && onSearch(value)
        }
        onChange={(event) => onChange(event.currentTarget.value)}
        placeholder={placeholder}
        value={value}
      />
      {value && (
        <div
          onMouseDown={() => onChange('')}
          className="text-ds-natural-600 mr-1.5 cursor-pointer"
        >
          <CloseOutlineIcon color={ColorHex.natural200} />
        </div>
      )}
    </div>
  );
};
